import React from 'react';
import { Badge } from '@fluentui/react-components';
import { observer } from 'owa-mobx-react';

interface OwaHeaderButtonBadgeProps {
    id: string;
    getCount: () => number;
    display?: 'count' | 'dot';
    className?: string;
}

const OwaHeaderButtonBadge: React.FC<OwaHeaderButtonBadgeProps> = observer(
    ({ id, getCount, display = 'count', className }) => {
        const badgeCount = getCount();

        if (badgeCount <= 0) {
            return null;
        }

        return display === 'dot' ? (
            <Badge
                id={id}
                aria-hidden={true}
                appearance="filled"
                color="danger"
                size="tiny"
                className={className}
            />
        ) : (
            <Badge id={id} appearance="filled" color="danger" size="small" className={className}>
                {badgeCount}
            </Badge>
        );
    },
    'OwaHeaderButtonBadge'
);

export default OwaHeaderButtonBadge;
